import { format, utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import addDays from 'date-fns/addDays';
import startOfDay from 'date-fns/startOfDay';
import { useEffect, useState } from 'react';

function useSupportStatus(
  openingHour: number,
  closingHour: number,
  supportTimeZone: string,
) {
  const [isLive, setIsLive] = useState(false);
  const [nextOpeningTime, setNextOpeningTime] = useState('');
  const clientTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  useEffect(() => {
    const checkIfLive = () => {
      const now = new Date();
      const nowSupportTime = utcToZonedTime(now, supportTimeZone);

      const todayOpening = startOfDay(nowSupportTime);
      todayOpening.setHours(openingHour, 0, 0, 0);
      const todayClosing = startOfDay(nowSupportTime);
      todayClosing.setHours(closingHour, 0, 0, 0);

      setIsLive(
        nowSupportTime >= todayOpening && nowSupportTime < todayClosing,
      );

      const nextOpeningTime =
        nowSupportTime.getHours() >= closingHour
          ? startOfDay(addDays(nowSupportTime, 1))
          : startOfDay(nowSupportTime);
      nextOpeningTime.setHours(openingHour, 0, 0, 0);

      const nextOpeningClientTime = utcToZonedTime(
        zonedTimeToUtc(nextOpeningTime, supportTimeZone),
        clientTimeZone,
      );
      const formattedNextOnlineTime = format(nextOpeningClientTime, 'p', {
        timeZone: clientTimeZone,
      });

      setNextOpeningTime(formattedNextOnlineTime);
    };

    const interval = setInterval(checkIfLive, 60000);
    checkIfLive();

    return () => clearInterval(interval);
  }, [openingHour, closingHour, supportTimeZone, clientTimeZone]);

  return { isLive, nextOpeningTime };
}

export default useSupportStatus;
